import thirPartPayBg from "../../../assets/image/store/third_way_bg.png"; 
import selectThirPay from "../../../assets/image/store/selectThirPay.png"; 
import selectInnerPay from "../../../assets/image/store/selectGooglePay.png"; 
import whiteProductSwitchBtn from "../../../assets/image/store/white-product-change.png"; 
import triangleDown from "../../../assets/image/icons/triangle-down.png"; 
import more from "../../../assets/image/icons/white-more.png"; 
import whiteMall from "../../../assets/image/store/location-omni.png"; 
import whiteShopingCar from "../../../assets/image/store/shop-omni.png"; 
import whiteMoney from "../../../assets/image/store/money-omni.png"; 
import whiteMoneyActive from "../../../assets/image/store/money-omni-active.png"; 
import whiteMoneyNormal from "../../../assets/image/store/money-omni-normal.png"; 
import payFailBg from "../../../assets/image/store/result-type-wrapper-red.png"; 
import paySuccessBg from "../../../assets/image/store/result-type-wrapper.png"; 
import paySuccess from "../../../assets/image/store/success-omni.png"; 
import payStoring from "../../../assets/image/store/waiting-omni.png"; 
import payFail from "../../../assets/image/store/fail-omni.png"; 
import playGameIcon from "../../../assets/image/icons/playGame.png"; 
import serviceIcon from "../../../assets/image/icons/service.png"; 
import switchIcon from "../../../assets/image/icons/switch.png"; 
import loadding from "../../../assets/image/icons/loading-omni.png"; 
import bindIcon from "../../../assets/image/icons/account-omni.png"; 
import userIcon from "../../../assets/image/icons/account-omni.png"; 
import ellipsisIcon from "../../../assets/image/icons/question-omni.png"; 
import textIcon from "../../../assets/image/icons/service-omni.png"; 
import accountFollowIcon from "../../../assets/image/icons/account-omni.png"; 
import exchangeIcon from "../../../assets/image/icons/gift-omni.png"; 
import fundTermsIcon from "../../../assets/image/icons/service-omni.png"; 
import survey from "../../../assets/image/icons/survey-icon-omni.png"; 
import deleteIcon from "../../../assets/image/icons/delete-icon-omni.png"; 
import settingIcon from "../../../assets/image/icons/default-icon-omni.png"; 
import selectHili from "../../../assets/image/icons/arrow-right-omni.png"; 
import closeBtn from "../../../assets/image/icons/dialog-close-omni.png"; 
import dialogblueBg from "../../../assets/image/icons/dialog-omni-bg.png"; 
import headerBg from "../../../assets/image/passport/passport-bg-omni.png"; 
import loginBg from "../../../assets/image/webLogin/loginBg.png"; 
import userName from "../../../assets/image/icons/account-user.png"; 
import password from "../../../assets/image/icons/account-pwd.png"; 
import starNormal from "../../../assets/image/support/star-normal-omni.png"; 
import blueStar from "../../../assets/image/support/star-score-omni.png"; 
import serviceDefaultAvatar from "../../../assets/image/support/potrait-service-blue.png"; 
import userDefaultAvatar from "../../../assets/image/support/potrait-user-omni.png"; 
import userInfoDefaultAvatar from "../../../assets/image/support/user-avatar-omni.png"; 
import userAccount from "../../../assets/image/icons/account-user.png"; 
import userPwd from "../../../assets/image/icons/account-pwd.png"; 
import userSafe from "../../../assets/image/icons/account-safe.png"; 
import userEmail from "../../../assets/image/icons/account-email.png"; 
import supportAdd from "../../../assets/image/support/cross-icon-omni.png"; 
import quessionListIcon from "../../../assets/image/support/question.png"; 
import quessionListTopIcon from "../../../assets/image/support/quession-list-top-omni.png"; 
import selectListIcon from "../../../assets/image/support/arrow-right-omni.png"; 
import pageContainerBg from "../../../assets/image/icons/page-container-bg.png"; 
import supportSearchIcon from "../../../assets/image/support/search.png"; 
import shortcutIcon from "../../../assets/image/icons/shortcut.png"; 
let $buttonBlue = '#369dfd'
let $lightBlue = '#c0dfff'
let $middleBlue = '#369dfd'
let $headerBg = '#e9f4ff'
let $testBorder = `1px solid ${$headerBg}`
let $selectTriggerBtn = {
  'border' : '1px solid #bcd5ef',
  'color' : '#899eb9',
  'padding' : '0 10px'
}
let $dialogScale = 550 / 736
let $dialogblueBgStyles = {
}
let $storePayBtn = {
  'width' : '16px',
  'height' : '15px',
  'position' : 'absolute',
  'right' : '50px',
  'top' : '50%',
  'transform' : 'translateY(-50%)'
}
let $selectPayType = {
  'width' : '230px',
  'height' : '60px',
  'line-height' : '60px',
  'background-color' : 'transparent'
}
let $passportFunctionIconStyles = {
  'background-repeat' : 'no-repeat',
  'width' : '52px',
  'height' : '52px',
  'background-position' : 'center center',
  'background-size' : 'cover !important'
}
let $AccountFunctionIconStyles = {
  'background-repeat' : 'no-repeat',
  'background-size' : '100% 100% !important'
}
let $activeListItem = {
  'border' : '2px solid #369dfd',
  'color' : '#369dfd',
  'border-width' : '2px'
}
let $fillBtnVh = {
  'width' : '100%',
  'height' : '6vh',
  'line-height' : '6vh',
  'font-size' : '3vh',
  'background-color' : 'transparent'
}

let $noRpBg = function($img){ 
  return {
  'background-image' : `url( ${$img})`,
  'background-repeat' : 'no-repeat'
  }

}

  export default {
'vlink' : { 

 typeTheme :{ 
 'repaireAccountBtn' : { 
  'background-color' : '#c0dfff'
 
}} 
}
,
'button' : { 
  commonTheme : {
  'border-radius' : '10px',
  'font-size' : '32px',
  'height' : '90px',
  'line-height' : '90px',
  'color' : 'white',
  'background-color' : $buttonBlue,
  'border' : '0',
  'width' : '500px',
  'cursor' : 'pointer',
  'font-weight' : '500',
  'outline' : 'none'
  },
 typeTheme :{ 
 'createWorkBtn' : { 
  'width' : '100%'
 
},
 'repaireAccountApplyBtn' : { 
  'height' : '40px',
  'line-height' : '40px',
  'width' : '288px',
  'margin' : '50px auto 0',
  'font-size' : '18px',
  'color' : '#fff',
  'background-color' : '#c0dfff'
 
},
 'repaireAccountQueryBtn' : { 
  'height' : '40px',
  'line-height' : '40px',
  'width' : '288px',
  'margin' : '50px auto 0',
  'font-size' : '18px',
  'color' : '#fff',
  'background-color' : '#c0dfff'
 
},
 'markScoreMainClose' : { 
  'background' : `url( ${closeBtn})`,
  'width' : '40px',
  'height' : '40px',
  'background-size' : 'cover',
  'top' : '0',
  'right' : '0'
 
},
 'long' : { 
  'width' : '456px'
 
},
 'short' : { 
  'width' : '300px'
 
},
 'shortWidth' : { 
  'position' : 'initial',
  'margin' : '60px 0 0',
  'width' : '100%',
  'color' : '#fff',
  'border-radius' : '12px',
  'background-color' : '#369dfd'
 
},
 'edit' : { 
  'width' : '154px',
  'height' : '72px',
  'line-height' : '72px',
  'color' : '#369dfd',
  'font-size' : '32px',
  'font-weight' : 'normal',
  'display' : 'inline-block',
  'vertical-align' : 'middle',
  'background-color' : '#fff'
 
},
 'fill' : { 
  'width' : '100%',
  'background-color' : $middleBlue
 
},
 'fillLightDialog' : { 
  'width' : '100%',
  'background' : '#369dfd',
  'border-radius' : '12px',
  'height' : '72px',
  'line-height' : '72px'
 
},
 'fillLight' : { 
  'background-color' : 'transparent',
  'height' : '90px',
  'line-height' : '90px',
  'color' : '#369dfd',
  'border' : '1px solid #369dfd',
  'width' : '100%'
 
},
 'fillLights' : { 
  'width' : '100%',
  'color' : '#fff',
  'border-radius' : '12px',
  'background-color' : '#369dfd',
  'position' : 'initial',
  'margin' : '0',
  'margin-top' : '78px'
 
},
 'fillLightVh' : { 
  ...$fillBtnVh,
  'background-color' : '#369dfd',
  'font-weight' : '500',
  'border-radius' : '12px'
 
},
 'fillEmtyBorderVh' : { 
  ...$fillBtnVh,
  'color' : '#369dfd',
  'font-weight' : '500',
  'border-radius' : '12px',
  'border' : '1px solid #369dfd'
 
},
 'storeBtn' : { 
  'width' : '100%',
  'background-color' : '#369dfd',
  'margin-top' : '202px'
 
},
 'bankInvoiceBtn' : { 
  'width' : '90%',
  'background-color' : '#369dfd'
 
},
 'refresh' : { 
  'background-color' : 'transparent',
  'border-radius' : '0',
  'margin-left' : '0',
  'height' : '70px',
  'width' : '50px',
  'filter' : 'brightness(0.6)'
 
},
 'selectResetPwd' : { 
  'width' : '160px',
  'height' : '50px',
  'line-height' : '50px',
  'font-size' : '18px'
 
},
 'selectPayType' : { 
  'background-image' : 'none;',
  'width' : '251px'
 
},
 'selectInnerWay' : { 
  'background-image' : 'none;',
  'width' : '251px'
 
},
 'switchProduct' : { 
  'background-image' : `url( ${whiteProductSwitchBtn})`,
  'width' : '56px',
  'height' : '56px',
  'background-color' : 'transparent',
  'border-radius' : '0'
 
},
 'returnGame' : { 
  'background-color' : 'transparent',
  'height' : '90px',
  'line-height' : '90px',
  'color' : '#369dfd',
  'border' : '1px solid #369dfd',
  'width' : '100%'
 
},
 'reStore' : { 
  'background-color' : '#369dfd',
  'height' : '90px',
  'line-height' : '90px',
  'color' : '#fff',
  'width' : '100%'
 
},
 'swtichAccount' : { 
  'height' : '40.4px',
  'border' : '0',
  'width' : 'auto',
  'padding-left' : '0',
  'padding-right' : '25px',
  'font-size' : '22.4px',
  'z-index' : '2',
  'background-color' : 'transparent',
  'line-height' : '40px',
  'transform' : 'translateY(40px)'
 
},
 'closeBtn' : { 
  'width' : '31px',
  'height' : '31px',
  'font-size' : 'initial',
  'background-image' : `url( ${closeBtn})`,
  'background-color' : 'transparent'
 
},
 'shortCancel' : { 
  'background-color' : 'transparent',
  'border' : '1px solid #369dfd',
  'line-height' : '60px',
  'height' : '60px',
  'width' : '210px',
  'color' : '#369dfd',
  'border-radius' : '30px'
 
},
 'shortConfirm' : { 
  'line-height' : '60px',
  'border' : '0',
  'height' : '60px',
  'width' : '210px',
  'color' : 'white',
  'border-radius' : '30px'
 
},
 'lightShort' : { 
  'font-size' : '22px',
  'background-color' : 'transparent',
  'color' : '#369dfd'
 
},
 'grayShort' : { 
  'background' : 'transparent',
  'color' : '#899eb9'
 
},
 'logoutBtn' : { 
  'width' : 'auto',
  'background' : 'transparent',
  'height' : '4vh',
  'line-height' : '4vh',
  'font-size' : '1.8vh',
  'color' : '#81acd9',
  'padding' : '0',
  'border-radius' : '0',
  'font-weight' : 'bold'
 
},
 'showServiceList' : { 
  'position' : 'initial',
  'margin' : '20px 0 0',
  'width' : '100%',
  'color' : '#369dfd',
  'border-radius' : '12px',
  'box-sizing' : 'border-box',
  'background-color' : 'transparent',
  'border' : '1px solid #369dfd'
 
},
 'supportReturnGame' : { 
  'width' : '100%',
  'top' : '260px',
  'position' : 'initial',
  'display' : 'block',
  'transform' : 'none',
  'margin-top' : '89px'
 
},
 'lightfill' : { 
  'width' : '100%',
  'height' : '72px',
  'font-size' : '25.6px',
  'line-height' : '72px'
 
}} 
}
,
'selectTriggerBtn' : { 
  commonTheme : {
  'height' : '40px',
  'line-height' : '40px',
  'background-color' : 'white'
  },
 typeTheme :{ 
 'locationSelect' : { 
  'width' : '237px',
  'border-radius' : '8px',
  ...$selectTriggerBtn
 
},
 'amountSelect' : { 
  ...$selectTriggerBtn,
  'width' : '278px',
  'border-color' : '#369dfd',
  'color' : '#369dfd',
  'border-radius' : '8px'
 
},
 'bankSelect' : { 
  ...$selectTriggerBtn,
  'width' : '60%',
  'height' : '60px',
  'margin' : '0 auto',
  'text-align' : 'center'
 
}} 
}
,
'title' : { 
  commonTheme : {
  'color' : '#2d456d',
  'font-size' : '28px',
  'line-height' : '32px'
  },
 typeTheme :{ 
 'articleTtile' : { 
  'font-weight' : '600',
  'font-size' : '28px',
  'color' : '#899eb9'
 
},
 'dialogTitle' : { 
  'font-size' : '25.6px',
  'color' : '#2d456d',
  'margin-top' : '51.2px',
  'margin-bottom' : '33px'
 
},
 'switchTitle' : { 
  'font-size' : '40px',
  'color' : '#414141'
 
}} 
}
,
'headerContainer' : { 
  commonTheme : {
  'background-color' : '#fff',
  'padding' : '0 30px',
  'color' : '#2d456d',
  'font-weight' : '600',
  'box-sizing' : 'border-box'
  },
 typeTheme :{ 
 'supportHeader' : { 
  'color' : '#fff',
  'background-color' : '#369dfd'
 
}} 
}
,
'footerContainer' : { 
  commonTheme : {
  'height' : '180px',
  'border-radius' : '8px',
  'padding' : '20px',
  'padding-bottom' : '0',
  'background-color' : '#fff'
  },
 typeTheme :{ 
 'supportFooter' : { 
  'height' : '120px',
  'display' : 'flex',
  'padding' : '0 45px',
  'align-items' : 'center',
  'justify-content' : 'space-between',
  'border-radius' : '0 !important',
  'background' : '#369dfd !important'
 
}} 
}
,
'SelectGroup' : { 
  commonTheme : {
  'color' : $middleBlue,
  'border' : `solid 1px ${$middleBlue}`,
  'border-radius' : '20px',
  'background' : 'white',
  'top' : '25px'
  },
 typeTheme :{ 
 'selectStoreInfo' : { 
  'width' : '100%',
  'height' : '4.2vh',
  'border-radius' : '6px',
  'padding' : '0 2vh',
  'margin-bottom' : '1.7vh',
  'margin-left' : '0',
  'top' : '0'
 
}} 
}
,
'select' : { 
  commonTheme : {
  'color' : $middleBlue,
  'border' : `solid 1px ${$middleBlue}`,
  'border-radius' : '6px',
  'background' : 'white',
  'top' : '25px'
  },
 typeTheme :{ 
 'selectStoreInfo' : { 
  'width' : '100%',
  'height' : '4.2vh',
  'border-radius' : '6px',
  'padding' : '0 2vh',
  'margin-bottom' : '1.7vh',
  'margin-left' : '0',
  'top' : '0'
 
},
 'selectLang' : { 
  'margin-right' : '3vh',
  'top' : '0'
 
},
 'selectLangLogin' : { 
  'margin-right' : '3vh',
  'top' : '-6vh',
  'background-color' : 'transparent',
  'border-radius' : '10px',
  'border-color' : '#369dfd',
  'color' : '#369dfd'
 
}} 
}
,
'block' : { 

 typeTheme :{ 
 'payWayBtn' : { 
  'border' : `1px solid ${$middleBlue}`
 
},
 'line' : { 
  'background' : '#cee3f9'
 
},
 'price' : { 
  'background' : '#74b3f5'
 
},
 'storeOrder' : { 
  'background' : '#fff',
  'border-radius' : '8px',
  'color' : '#2d456d',
  'font-size' : '24px',
  'font-weight' : '600',
  'width' : '620px',
  'padding' : '0 40px'
 
},
 'pageContainer' : { 
  'background' : '#f1f1f1',
  'background-image' : `url( ${pageContainerBg})`,
  'background-repeat' : 'no-repeat',
  'background-size' : '100% auto',
  'background-position' : 'bottom center'
 
},
 'storeOrderBorder' : { 
  'border-bottom' : '1px solid #c3def9'
 
},
 'funtionListItem' : { 
  'display' : 'flex',
  'color' : '#2d456d',
  'align-items' : 'center'
 
},
 'accountFunctionListItem' : { 
  'display' : 'flex',
  'width' : 'auto',
  'color' : '#2d456d',
  'align-items' : 'center'
 
},
 'passportHeader' : { 
  'background' : '#369dfd',
  'margin-bottom' : '0',
  'position' : 'relative',
  'z-index' : '2',
  'height' : '248px',
  'box-sizing' : 'border-box',
  'padding' : '67.2px 35.2px 36.8px',
  'background-image' : `url( ${headerBg})`,
  'background-size' : 'cover',
  'background-position' : 'bottom center'
 
},
 'accountDialog' : { 
  ...$dialogblueBgStyles,
  'border-radius' : '12px',
  'background-image' : `url( ${dialogblueBg})`,
  'background-size' : '100% 100%'
 
},
 'accountDialogContainer' : { 
  'background-color' : 'transparent',
  'height' : `${$dialogScale} * 476 + px`
 
},
 'tipsDialogWrapper' : { 
  ...$dialogblueBgStyles,
  'background-color' : 'transparent'
 
},
 'loginTipsDialogWrapper' : { 
  ...$dialogblueBgStyles,
  'background-color' : 'white',
  'border-radius' : '1.2vh',
  'border' : '0',
  'padding' : '1.4vh 1.5vh'
 
},
 'dialogBtnDocker' : { 
  'height' : 'auto',
  'margin-top' : '38.4px',
  'margin-bottom' : '20px'
 
},
 'tipsDialog' : { 
  'border-radius' : '8px'
 
},
 'accountSetting' : { 
  'background-color' : '#f1f1f1',
  'background-image' : `url( ${pageContainerBg})`,
  'background-repeat' : 'no-repeat',
  'background-size' : '100% auto',
  'background-position' : 'bottom center'
 
},
 'editorWrapper' : { 
  'background' : 'transparent'
 
},
 'countDown' : { 
  'background' : 'transparent',
  'display' : 'flex',
  'align-items' : 'center',
  'font-size' : '20px',
  'width' : '160px'
 
},
 'activeListItem' : { 
  ...$activeListItem
 
},
 'webLogin' : { 
  'background-color' : '#f1f1f1'
 
},
 'loginBox' : { 
  'border-radius' : '12px'
 
},
 'gameSelectBox' : { 
  'background-color' : 'white'
 
},
 'gameSelectBoxStore' : { 
  'background-color' : 'white'
 
},
 'serviceSuccessPopup' : { 
  'border' : '0',
  'padding' : '35px',
  'border-radius' : '8px',
  ...$dialogblueBgStyles,
  'min-height' : '500px',
  'width' : '615px',
  'height' : 'auto',
  'box-sizing' : 'border-box'
 
},
 'scoreBlock' : { 
  'width' : '620px',
  'min-height' : '300px',
  'height' : 'auto',
  'background-color' : 'white',
  'border-radius' : '12px',
  'border' : 'none',
  'border-width' : '30px 35px 40px 35px',
  'border-style' : 'solid',
  'border-color' : '#fff'
 
},
 'maintainScoreImg' : { 
  'display' : 'block',
  'width' : '236px',
  'height' : '182px',
  'margin' : '10px auto 40px auto',
  'background-image' : `url( ${paySuccess})`,
  'background-repeat' : 'no-repeat',
  'background-size' : 'cover',
  'position' : 'initial'
 
},
 'scoreStartContainer' : { 
  'top' : '34px',
  'position' : 'initial',
  'margin-top' : '34px'
 
},
 'commentTips' : { 
  'top' : '102px',
  'font-weight' : '400',
  'font-size' : '26px',
  'color' : '#2d456d',
  'position' : 'initial',
  'margin-top' : '32px'
 
},
 'loadding' : { 
  'margin-top' : '246px',
  'background-image' : `url( ${loadding})`
 
}} 
}
,
'blockClickable' : { 

 typeTheme :{ 
 'payWayDetail' : { 
  'border' : '1px solid #adbbcc',
  'border-radius' : '8px'
 
},
 'moreGameText' : { 
  'color' : '#369dfd'
 
},
 'bankWayDetail' : { 
  'border' : `1px solid ${$middleBlue}`,
  'padding-right' : '30px',
  'flex-wrap' : 'wrap',
  'height' : 'auto'
 
}} 
}
,
'add' : { 
  commonTheme : {
  'background-image' : `url( ${supportAdd})`
  }}
,
'content' : { 

 typeTheme :{ 
 'tipsContent' : { 
  'font-size' : '22.4px',
  'color' : '#2d456d'
 
},
 'passportTips' : { 
  'border-bottom' : '1px solid #d5d5d5'
 
}} 
}
,
'mark' : { 
  commonTheme : {
  'color' : $middleBlue,
  'text-decoration' : 'underline'
  },
 typeTheme :{ 
 'thirdPartName' : { 
  'color' : '#369dfd',
  'text-decoration' : 'none'
 
},
 'amount' : { 
  'color' : '#369dfd',
  'text-decoration' : 'none'
 
},
 'coinName' : { 
  'color' : '#414141',
  'text-decoration' : 'none'
 
},
 'contactService' : { 
  'color' : '#369dfd'
 
}} 
}
,
'supportReplyInput' : { 
  commonTheme : {
  'height' : '72px',
  'outline' : 'none',
  'font-size' : '26px',
  'color' : '#2d456d',
  'line-height' : '72px',
  'margin-right' : '20px',
  'font-weight' : '200',
  'border-radius' : '12px',
  'display' : 'inline-block',
  'vertical-align' : 'middle',
  'background-color' : '#fff'
  }}
,
'icon' : { 

 typeTheme :{ 
 'searchType' : { 
  'background-image' : `url( ${supportSearchIcon})`,
  'width' : '25px',
  'height' : '26px'
 
},
 'commonHeaderBack' : { 
  'top' : '26px'
 
},
 'loginBtnLeft' : { 
  'display' : 'none'
 
},
 'loginBtnRight' : { 
  'display' : 'none'
 
},
 'loginBtnLeft2' : { 
  'display' : 'none'
 
},
 'loginBtnRight2' : { 
  'display' : 'none'
 
},
 'loginBoxLeftTop' : { 
  'display' : 'none'
 
},
 'loginBoxRightTop' : { 
  'display' : 'none'
 
},
 'loginBoxLeftBottom' : { 
  'display' : 'none'
 
},
 'loginBoxRightBottom' : { 
  'display' : 'none'
 
},
 'thirdPartNameIconLeft' : { 
  'display' : 'none'
 
},
 'thirdPartNameIconRight' : { 
  'display' : 'none'
 
},
 'resultBackBtnLeft' : { 
  'display' : 'none'
 
},
 'resultBackBtnRight' : { 
  'display' : 'none'
 
},
 'resultHistoryBtnLeft' : { 
  'display' : 'none'
 
},
 'resultHistoryBtnRight' : { 
  'display' : 'none'
 
},
 'supportReturnGameHelmet' : { 
  'display' : 'inline-block'
 
},
 'commonBtnLeft' : { 
  'display' : 'none'
 
},
 'commonBtnRight' : { 
  'display' : 'none'
 
},
 'createWorkBtnLeft' : { 
  'display' : 'none'
 
},
 'createWorkBtnRight' : { 
  'display' : 'none'
 
},
 'submitBtnCheck' : { 
  'display' : 'inline-block'
 
},
 'select' : { 
  'background-image' : 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAALCAMAAABFyS02AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAb1BMVEUAAACBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNkAAAAvcOsnAAAAI3RSTlMALbcPwgoj47gGIirqrAMy8KABPPWTkkb5hFL8dl7+a2x6e1lW5/kAAAABYktHRACIBR1IAAAACXBIWXMAAAsSAAALEgHS3X78AAAAbElEQVQI112ORQ7AMAwEt5xiysz7/z82URUV5uLxWrINy3bwwrEtuHS9J/FUCz+gCE0SCgYRECdMszvJUiaxFpmzKLWUBXN5D6uaja4t68qs6HoOwMC+ew6NE+eZ0/h+Z1kVCz5s5I4fx2nsAmZ2Bl6CPGunAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE5LTEyLTEwVDExOjAxOjUzKzA4OjAwUYCEIAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOS0xMi0xMFQxMTowMTo1MyswODowMCDdPJwAAAAASUVORK5CYII=);',
  'width' : '18px',
  'height' : '11px'
 
},
 'selectvh' : { 
  'background-image' : `url( ${selectHili})`,
  'width' : '0.8vh',
  'height' : '1.1vh',
  'background-size' : '100% 100%',
  'transform' : 'rotate(90deg) translateX(-50%)'
 
},
 'quession' : { 
  'background-image' : `url( ${quessionListTopIcon})`,
  'top' : '32px',
  'transform' : 'none',
  'width' : '30px',
  'height' : '30px'
 
},
 'quessionList' : { 
  'background-image' : `url( ${quessionListIcon})`,
  'width' : '30px',
  'height' : '30px'
 
},
 'selectList' : { 
  'background-image' : `url( ${selectListIcon})`,
  'width' : '11px',
  'height' : '18px',
  'background-size' : '100% 100%'
 
},
 'quessionSelect' : { 
  'border-top-color' : '#2d456d'
 
},
 'more' : { 
  'background-image' : `url( ${more})`
 
},
 'before' : { 
  'border-right-color' : '#74b3f5'
 
},
 'global' : { 
  'width' : '25px',
  'height' : '31px',
  'margin-left' : '10px',
  'background-image' : `url( ${whiteMall})`
 
},
 'shoppingCar' : { 
  'width' : '30px',
  'height' : '30px',
  'margin-left' : '10px',
  'background-image' : `url( ${whiteShopingCar})`
 
},
 'whiteMoney' : { 
  'width' : '27px',
  'height' : '24px',
  'margin-left' : '10px',
  ...$noRpBg(whiteMoney)
 
},
 'moneyNoraml' : { 
  'width' : '27px',
  'height' : '24px',
  'margin-left' : '10px',
  ...$noRpBg(whiteMoneyNormal)
 
},
 'moneyNoraml-active' : { 
  ...$noRpBg(whiteMoneyActive)
 
},
 'storesuccess' : { 
  'width' : '236px',
  'height' : '182px',
  'background-image' : `url( ${paySuccess})`,
  'background-repeat' : 'no-repeat'
 
},
 'storefail' : { 
  'width' : '236px',
  'height' : '182px',
  'background-image' : `url( ${payFail})`,
  'background-repeat' : 'no-repeat'
 
},
 'storestoring' : { 
  'width' : '236px',
  'height' : '182px',
  'background-image' : `url( ${payStoring})`,
  'background-repeat' : 'no-repeat'
 
},
 'playGame' : { 
  'background-image' : `url( ${playGameIcon})`,
  'background-repeat' : 'no-repeat',
  'width' : '37px',
  'height' : '33px',
  'margin-right' : '10px'
 
},
 'service' : { 
  'background-image' : `url( ${serviceIcon})`,
  'background-repeat' : 'no-repeat',
  'width' : '30px',
  'height' : '36px',
  'margin-right' : '10px'
 
},
 'switch' : { 
  'background-image' : `url( ${switchIcon})`,
  'background-repeat' : 'no-repeat',
  'width' : '22px',
  'height' : '16px'
 
},
 'bindIcon' : { 
  'background-image' : `url( ${bindIcon})`,
  ...$passportFunctionIconStyles
 
},
 'userIcon' : { 
  'background-image' : `url( ${userIcon})`,
  ...$passportFunctionIconStyles
 
},
 'ellipsisIcon' : { 
  'background-image' : `url( ${ellipsisIcon})`,
  ...$passportFunctionIconStyles
 
},
 'textIcon' : { 
  'background-image' : `url( ${textIcon})`,
  ...$passportFunctionIconStyles
 
},
 'accountFollowIcon' : { 
  'background-image' : `url( ${accountFollowIcon})`,
  ...$passportFunctionIconStyles
 
},
 'exchangeIcon' : { 
  'background-image' : `url( ${exchangeIcon})`,
  ...$passportFunctionIconStyles
 
},
 'fundTermsIcon' : { 
  'background-image' : `url( ${fundTermsIcon})`,
  ...$passportFunctionIconStyles
 
},
 'survey' : { 
  'background-image' : `url( ${survey})`,
  ...$passportFunctionIconStyles
 
},
 'deleteIcon' : { 
  'background-image' : `url( ${deleteIcon})`,
  ...$passportFunctionIconStyles
 
},
 'settingIcon' : { 
  'background-image' : `url( ${deleteIcon})`,
  ...$passportFunctionIconStyles
 
},
 'userAccount' : { 
  'background-image' : `url( ${userAccount})`,
  ...$AccountFunctionIconStyles,
  'width' : '30.4px',
  'height' : '28px'
 
},
 'userPwd' : { 
  'background-image' : `url( ${userPwd})`,
  ...$AccountFunctionIconStyles,
  'width' : '27.2px',
  'height' : '29.6px'
 
},
 'userSafe' : { 
  'background-image' : `url( ${userSafe})`,
  ...$AccountFunctionIconStyles,
  'width' : '24px',
  'height' : '28.8px'
 
},
 'userEmail' : { 
  'background-image' : `url( ${userEmail})`,
  ...$AccountFunctionIconStyles,
  'width' : '29.6px',
  'height' : '22.4px'
 
},
 'selectHili' : { 
  'background-image' : `url( ${selectHili})`,
  'background-repeat' : 'no-repeat',
  'background-size' : '100% 100%',
  'width' : '10.4px',
  'height' : '20px',
  'top' : '50%',
  'bottom' : 'auto'
 
},
 'selectHiliAccount' : { 
  'background-image' : `url( ${selectHili})`,
  'background-repeat' : 'no-repeat',
  'background-size' : '100% 100%',
  'width' : '10.4px',
  'height' : '20px',
  'top' : '50%',
  'bottom' : 'auto'
 
},
 'userName' : { 
  'background-image' : `url( ${userName})`,
  'width' : '2.8vh',
  'height' : '2.7vh',
  'background-repeat' : 'no-repeat',
  'background-size' : 'cover'
 
},
 'password' : { 
  'background-image' : `url( ${password})`,
  'width' : '2.7vh',
  'height' : '2.9vh',
  'background-repeat' : 'no-repeat',
  'background-size' : 'cover'
 
},
 'helmet' : { 
  'display' : 'none'
 
},
 'folder' : { 
  'display' : 'none'
 
},
 'service' : { 
  'background-image' : `url( ${serviceIcon})`,
  'width' : '30px',
  'height' : '36px'
 
},
 'serviceDefaultAvatar' : { 
  'background-image' : `url( ${serviceDefaultAvatar})`
 
},
 'userDefaultAvatar' : { 
  'background-image' : `url( ${userDefaultAvatar})`
 
},
 'userInfoDefaultAvatar' : { 
  'background-image' : `url( ${userInfoDefaultAvatar})`,
  'width' : '96px',
  'height' : '96px',
  'background-size' : 'cover',
  'margin' : '12px auto'
 
},
 'line' : { 
  'background-color' : '#c5d4eb'
 
},
 'custom' : { 
  'color' : '#899eb9'
 
},
 'showChildpayTypeIcon' : { 
  'background-image' : `url( ${more})`
 
},
 'storeBtnLeft' : { 
  'display' : 'none'
 
},
 'storeBtnRight' : { 
  'display' : 'none'
 
},
 'appleDeleteIcon' : { 
  'background-image' : `url( ${deleteIcon})`,
  ...$passportFunctionIconStyles
 
},
 'shortcutIcon' : { 
  'background-image' : `url( ${shortcutIcon})`,
  ...$passportFunctionIconStyles
 
}} 
}
,
'listItem' : { 

 typeTheme :{ 
 'active' : { 
  ...$activeListItem
 
},
 'selectItem' : { 
  'color' : '#2d456d',
  'border' : '1px solid #2d456d'
 
},
 'quessionItem' : { 
  'color' : '#2d456d',
  'padding-left' : '70px',
  'border' : '1px solid #2d456d'
 
},
 'selectItem-active' : { 
  'border-color' : $middleBlue
 
},
 'functionItem' : { 
  'height' : '105.6px',
  'background-color' : '#fff',
  'display' : 'flex',
  'border-radius' : '12px',
  'align-items' : 'center',
  'margin-bottom' : '22.4px',
  'position' : 'relative'
 
},
 'accountSettingItem' : { 
  'padding' : '0',
  'width' : 'auto',
  'margin' : '0 18.4px 0 18.4px',
  'background' : 'transparent',
  'display' : 'flex',
  'align-items' : 'center',
  'box-sizing' : 'border-box',
  'height' : '110.4px',
  'line-height' : '110.4px',
  'border-bottom' : '1px solid #c5d4eb'
 
},
 'locationItem' : { 
  'height' : '80px',
  'font-size' : '24px'
 
},
 'productSelectOptions' : { 
  'text-align' : 'left'
 
},
 'paymentItem' : { 
  'height' : '80px'
 
},
 'selectPayWayItem' : { 
  'border-radius' : '15px'
 
}} 
}
,
'thirPartPay' : { 
  commonTheme : {
  'background-image' : `url( ${thirPartPayBg})`,
  'border-radius' : '16px',
  'background-size' : 'cover'
  }}
,
'innerPay' : { 
  commonTheme : {
  'border-radius' : '16px'
  },
 typeTheme :{ 
 'oneStore' : { 
  'background' : 'black'
 
}} 
}
,
'list' : { 

 typeTheme :{ 
 'passportFunctionList' : { 
  'display' : 'block',
  'padding' : '33.6px 28.8px 0',
  'box-sizing' : 'border-box',
  'overflow' : 'hidden'
 
}} 
}
,
'editor' : { 

 typeTheme :{ 
 'passportAccountEditor' : { 
  'background' : 'transparent',
  'border-bottom-color' : '#c5d4eb'
 
},
 'loginEditor' : { 
  'border-color' : '#369dfd',
  'border-radius' : '12px',
  'color' : '#2d456d'
 
},
 'emailEditor' : { 
  'height' : '88px',
  'line-height' : '88px',
  'box-sizing' : 'border-box',
  'border' : '1px solid #369dfd',
  'border-radius' : '8px',
  'background-color' : 'transparent',
  'padding' : '0 25.6px'
 
},
 'passwordEditor' : { 
  'height' : '72px',
  'line-height' : '72px',
  'box-sizing' : 'border-box',
  'border' : '1px solid #2d456d',
  'border-radius' : '8px',
  'background-color' : 'transparent',
  'padding' : '0 25.6px'
 
}} 
}
,
'scoreStart' : { 
  commonTheme : {
  'background-image' : `url( ${starNormal})`,
  'background-size' : 'cover'
  },
 typeTheme :{ 
 'active' : { 
  'background-image' : `url( ${blueStar})`,
  'background-repeat' : 'no-repeat',
  'background-size' : 'cover'
 
}} 
}
,
'typeCategory' : { 
  commonTheme : {
  'color' : $middleBlue
  }}
,
'bankText' : { 
  commonTheme : {
  'color' : $middleBlue
  }}
,
'bankTotal' : { 
  commonTheme : {
  'border-color' : '#bcd5ef',
  'color' : '#414141',
  'border-radius' : '8px'
  }}
,
'storeLogo' : { 

 typeTheme :{ 
 'passportIco' : { 
  'width' : '52px',
  'height' : '52px',
  'left' : '39.2px'
 
}} 
}

}